/* The Standard - shared behaviour (loaded only on page.the-standard, deferred) */
(function () {
  'use strict';

  var desk = window.matchMedia('(min-width: 768px)');
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  function $(id) { return document.getElementById(id); }
  function clamp(v) { return Math.max(0, Math.min(1, v)); }

  /* ---------- reveals (both layouts) ---------- */
  var revealIo = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealIo.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  var sceneIo = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); sceneIo.unobserve(e.target); } });
  }, { threshold: 0.35 });

  var onceIo = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); onceIo.unobserve(e.target); } });
  }, { threshold: 0.4 });

  function initReveals(root) {
    root.querySelectorAll('.ts-root .reveal, .ts-root .fade').forEach(function (el) { revealIo.observe(el); });
    root.querySelectorAll('.ts-desktop .scene, .ts-desktop .checkpoint').forEach(function (el) { sceneIo.observe(el); });
    root.querySelectorAll('.ts-desktop .claim-line, .ts-desktop .m-origin').forEach(function (el) { onceIo.observe(el); });
  }

  /* ---------- desktop flow map ---------- */
  var flow = { len: 0, radLens: [], lastPhase: -1 };

  function initLen(p) {
    if (!p) return 0;
    var L = 0;
    try { L = p.getTotalLength(); } catch (e) { L = 0; }
    p.style.setProperty('--ts-len', L);
    p.style.strokeDashoffset = L;
    return L;
  }

  function initFlow() {
    flow.len = initLen($('flowFill'));
    flow.radLens = [];
    document.querySelectorAll('.ts-desktop [data-rad]').forEach(function (r) { flow.radLens.push(initLen(r)); });
    var svg = document.querySelector('.ts-desktop .map-svg');
    if (svg) {
      var h = svg.offsetHeight || svg.getBoundingClientRect().height;
      svg.style.setProperty('--ts-india-pan', (-(0.42 * h)).toFixed(1) + 'px');
    }
    flow.lastPhase = -1;
  }

  function drawLen(p, L, f) { if (p) p.style.strokeDashoffset = L * (1 - clamp(f)); }

  function setMapPhase(p) {
    var phase = p >= 0.75 ? 3 : p >= 0.55 ? 2 : p >= 0.30 ? 1 : 0;
    var fillEl = $('flowFill'), pulse = $('flowPulse');
    var fillFrac = clamp(p / 0.55);
    drawLen(fillEl, flow.len, fillFrac);
    if (pulse && fillEl) {
      pulse.classList.toggle('on', p > 0.02 && p < 0.92);
      try {
        var pt = fillEl.getPointAtLength(flow.len * fillFrac);
        pulse.setAttribute('cx', pt.x); pulse.setAttribute('cy', pt.y);
      } catch (e) {}
    }
    var de = $('nodeDE'), hq = $('nodeHQ'), inn = $('nodeIN');
    if (de) de.classList.toggle('on', p >= 0.02);
    if (hq) hq.classList.toggle('on', p >= 0.30);
    if (inn) inn.classList.toggle('on', p >= 0.78);

    var f3 = clamp((p - 0.75) / 0.25);
    document.querySelectorAll('.ts-desktop [data-rad]').forEach(function (r, i) { drawLen(r, flow.radLens[i] || 0, (f3 * 1.4) - i * 0.05); });
    document.querySelectorAll('.ts-desktop [data-city]').forEach(function (c, i) { c.classList.toggle('on', f3 > 0.15 + (i * 0.09)); });
    var svg = document.querySelector('.ts-desktop .map-svg');
    if (svg) svg.classList.toggle('india-focus', phase === 3);

    if (phase !== flow.lastPhase) {
      document.querySelectorAll('.ts-desktop .map-cap-phase').forEach(function (c, i) { c.classList.toggle('on', i === phase); });
      document.querySelectorAll('#mapRail span').forEach(function (s, i) { s.classList.toggle('on', i === phase); });
      flow.lastPhase = phase;
    }
  }

  /* ---------- scroll loop (throttled, one layout at a time) ---------- */
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    if (desk.matches) {
      var track = $('journeyTrack'), spine = $('spineFill');
      if (track && spine) {
        var r = track.getBoundingClientRect();
        spine.style.height = (clamp((vh * 0.55 - r.top) / r.height) * 100) + '%';
      }
      var driver = $('mapDriver');
      if (driver) {
        var d = driver.getBoundingClientRect();
        setMapPhase(clamp(-d.top / Math.max(1, d.height - vh)));
      }
    } else {
      var mdrv = $('m-mapDriver'), stage = $('mapStage'), mfill = $('mapFill');
      if (mdrv && stage && mfill) {
        var m = mdrv.getBoundingClientRect();
        var prog = clamp(-m.top / Math.max(1, mdrv.offsetHeight - stage.offsetHeight));
        stage.dataset.phase = Math.min(3, Math.floor(prog * 4));
        mfill.style.height = (prog * 100) + '%';
        stage.querySelectorAll('.mnode').forEach(function (n, i) { n.classList.toggle('on', prog * 100 >= i * 33.3 - 1); });
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; raf(update); } }

  /* ---------- card scrollers (desktop proof track + mobile strip) ---------- */
  function initScroller(scroller, cardSel, prev, next, dotsWrap, dotSel, dragToScroll) {
    if (!scroller || scroller.dataset.tsReady) return;
    scroller.dataset.tsReady = '1';
    var cards = scroller.querySelectorAll(cardSel);
    var last = Math.max(0, cards.length - 1);
    function step() {
      var c = cards[0]; if (!c) return scroller.clientWidth;
      var track = c.parentElement;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return c.getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (dotsWrap) dotsWrap.querySelectorAll(dotSel).forEach(function (d) {
      d.addEventListener('click', function () { scroller.scrollTo({ left: step() * (+d.dataset.i), behavior: 'smooth' }); });
    });
    function sync() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      if (prev) prev.toggleAttribute('disabled', scroller.scrollLeft <= 2);
      if (next) next.toggleAttribute('disabled', scroller.scrollLeft >= max);
      if (dotsWrap) {
        var i = Math.min(last, Math.round(scroller.scrollLeft / step()));
        dotsWrap.querySelectorAll(dotSel).forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }
    }
    scroller.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    if (dragToScroll) {
      var down = false, startX = 0, startScroll = 0, moved = 0;
      scroller.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = 0; startX = e.clientX; startScroll = scroller.scrollLeft;
        scroller.classList.add('dragging'); scroller.setPointerCapture(e.pointerId);
      });
      scroller.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX; moved = Math.max(moved, Math.abs(dx));
        scroller.scrollLeft = startScroll - dx;
      });
      var end = function (e) {
        if (!down) return; down = false; scroller.classList.remove('dragging');
        try { scroller.releasePointerCapture(e.pointerId); } catch (_) {}
      };
      scroller.addEventListener('pointerup', end);
      scroller.addEventListener('pointercancel', end);
      scroller.addEventListener('pointerleave', end);
      scroller.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    }
  }

  function initScrollers() {
    initScroller($('esScroll'), '.evidence', $('esPrev'), $('esNext'), $('esDots'), '.es-dot', true);
    initScroller(document.querySelector('#m-rbf .strip'), '.ecard', $('pPrev'), $('pNext'), $('pDots'), '.pdot', false);
  }

  /* ---------- boot ---------- */
  function boot() {
    initReveals(document);
    initFlow();
    initScrollers();
    update();
  }
  boot();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { initFlow(); onScroll(); });
  if (desk.addEventListener) desk.addEventListener('change', function () { initFlow(); onScroll(); });

  /* ---------- theme editor: re-run when a section is re-rendered ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.reveal, .fade, .scene, .checkpoint, .claim-line, .m-origin').forEach(function (el) { el.classList.add('in'); });
    initFlow();
    initScrollers();
    update();
  });
})();
